import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import Select from "react-select";
import { DatePicker } from "antd";
import moment from "moment";
import dayjs from "dayjs";

import { useNavigate } from "react-router-dom";

import { useAtom } from "jotai";
import { gbState, fYear } from "../../../components/shared/GlobalState";
import {
  FaArrowLeft,
  FaPlus,
  FaCalendarAlt,
  FaDollarSign,
  FaUser,
  FaListAlt,
} from "react-icons/fa";

import {
  incomeSourceOptions,
  paymentStatusOption,
} from "../../../components/Data/DropDownData";

const IncomeDuesAddChild = () => {
  let navigate = useNavigate();
  const inputWidth = "230px";
  const style = {
    control: (base) => ({
      ...base,
      border: "1px solid lightgray",
      boxShadow: "none", // This line disables the blue border
    }),
  };

  const [{ errorLogApi, placeHolderText, Category, user }] = useAtom(gbState);
  const [financial_year] = useState({
    value: user?.current_financial_year,
    label: user?.current_financial_year,
  });
  const [churchMembers, setChurchMembers] = useState([]);
  const [categoryList, setCategoryList] = useState();

  const [useOtherNonMember, setUseOtherNonMember] = useState(false);
  const [formData, setFormData] = useState({
    category_id: null,
    dues_title: null,
    description: null,
    member_id: null,
    start_date: null,
    pledged_amount: null,
    church_id: user?.church_id,
    preferred_payment_mode: null,
    status: 1,
    financial_year: financial_year?.value,
  });

  //Load categories
  useEffect(() => {
    const getDataFromServer = () => {
      let userToken = localStorage.getItem("token");

      let urlLink = `${process.env.REACT_APP_API_URL}/category/income/${user?.church_id}`;

      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      axios(config)
        .then((response) => {
          const oldData = response.data.Categorys;
          const updatedData = oldData.map((data) => ({
            value: data?._id,
            label: data?.category_name,
          }));
          setCategoryList(updatedData);
        })
        .catch((err) => {
          console.log("error api call ", err.response.data.message);
        });
    };
    getDataFromServer();
  }, []);

  //Load members
  useEffect(() => {
    let userToken = localStorage.getItem("token");
    const config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/user/church/${user?.church_id}`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios(config)
      .then((response) => {
        const members = response?.data?.users;
        setChurchMembers(
          members.map((member) => ({
            value: member._id,
            label: member.first_name + " " + member.last_name,
          }))
        );
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error);
        errorLogApi(error, "ChurchMemberList", "/income");
      });
  }, []);

  const handleChange = ({ currentTarget: input }) => {
    setFormData({
      ...formData,
      [input.name]: input.value,
    });
  };

  const handleAddIncome = (e) => {
    e.preventDefault();

    if (!formData?.pledged_amount) return toast.error("Please enter amount");

    let userToken = localStorage.getItem("token");

    const finData = {
      ...formData,
      financial_year: financial_year?.label,
      start_date: formData.start_date || dayjs().format("YYYY-MM-DD"), // Set default date if not set
    };

    console.log("Form Data:", formData);
    console.log("Final Data being sent:", finData);

    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/incomedues/add`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: finData,
    };

    axios(config)
      .then((response) => {
        toast.success("Dues Created Successfully.");
        navigate("/dues-income");
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
        errorLogApi(error, "IncomeduesAddChild", "/incomedues/add");
      });
  };

  return (
    <div className="flex justify-center p-8 w-full min-h-screen bg-gray-100">
      <div className="p-8 w-full max-w-2xl bg-white rounded-lg shadow-lg">
        <form
          onSubmit={(e) => handleAddIncome(e)}
          autoComplete="off"
          className="space-y-6"
        >
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-800">
              Add Dues Income
            </h2>
            <div className="flex space-x-2">
              <button
                type="button"
                className="flex items-center px-4 py-2 text-white bg-gray-600 rounded-md transition duration-300 hover:bg-gray-700"
                onClick={() => navigate(-1)}
              >
                <FaArrowLeft className="mr-2" /> Back
              </button>
              <button
                className="flex items-center px-4 py-2 text-white bg-blue-600 rounded-md transition duration-300 hover:bg-blue-700"
                type="submit"
              >
                <FaPlus className="mr-2" /> Create
              </button>
            </div>
          </div>

          <div className="space-y-4">
            <Select
              name="category_id"
              onChange={(selected) => {
                setFormData({
                  ...formData,
                  category_id: selected.value,
                });
              }}
              options={categoryList}
              placeholder={
                <div className="flex items-center">
                  <FaListAlt className="mr-2" />{" "}
                  {placeHolderText("Select Category")}
                </div>
              }
              className="w-full"
              styles={{
                ...style,
                control: (provided) => ({
                  ...provided,
                  borderColor: "#e2e8f0",
                  "&:hover": {
                    borderColor: "#cbd5e0",
                  },
                }),
              }}
            />

            <input
              className="p-3 w-full rounded-md border border-gray-300 transition duration-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              name="dues_title"
              type="text"
              required
              placeholder="Dues Title"
              autoComplete="off"
              onChange={handleChange}
            />

            <DatePicker
              className="w-full rounded-md border border-gray-300 transition duration-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              name="start_date"
              defaultValue={dayjs()}
              format="MM-DD-YYYY"
              onChange={(date) => {
                console.log("Date selected:", date);
                setFormData({
                  ...formData,
                  start_date: date ? date.format("YYYY-MM-DD") : null,
                });
              }}
              showToday={true}
              suffixIcon={<FaCalendarAlt className="text-gray-400" />}
            />

            <Select
              name="member_id"
              onChange={(selected) => {
                setFormData({
                  ...formData,
                  member_id: selected?.value,
                  other_non_member: null,
                });
              }}
              options={churchMembers}
              placeholder={
                <div className="flex items-center">
                  <FaUser className="mr-2" /> {placeHolderText("Select Member")}
                </div>
              }
              className="w-full"
              styles={{
                ...style,
                control: (provided) => ({
                  ...provided,
                  borderColor: "#e2e8f0",
                  "&:hover": {
                    borderColor: "#cbd5e0",
                  },
                }),
              }}
              isClearable
            />

            <div className="relative">
              <FaDollarSign className="absolute top-3 left-3 text-gray-400" />
              <input
                className="p-3 pl-10 w-full rounded-md border border-gray-300 transition duration-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                name="pledged_amount"
                type="number"
                required
                placeholder="Enter Amount"
                autoComplete="off"
                onChange={handleChange}
              />
            </div>

            <Select
              name="status"
              onChange={(selected) => {
                setFormData({
                  ...formData,
                  status: selected.value,
                });
              }}
              options={paymentStatusOption}
              placeholder={placeHolderText("Select Status")}
              className="w-full"
              styles={{
                ...style,
                control: (provided) => ({
                  ...provided,
                  borderColor: "#e2e8f0",
                  "&:hover": {
                    borderColor: "#cbd5e0",
                  },
                }),
              }}
              value={
                formData?.status &&
                paymentStatusOption.find((p) => p.value === formData?.status)
              }
            />

            <Select
              name="preferred_payment_mode"
              onChange={(selected) => {
                setFormData({
                  ...formData,
                  preferred_payment_mode: selected.value,
                });
              }}
              options={incomeSourceOptions}
              placeholder={placeHolderText("Preferred Mode")}
              className="w-full"
              styles={{
                ...style,
                control: (provided) => ({
                  ...provided,
                  borderColor: "#e2e8f0",
                  "&:hover": {
                    borderColor: "#cbd5e0",
                  },
                }),
              }}
            />

            <textarea
              className="p-3 w-full rounded-md border border-gray-300 transition duration-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              name="description"
              rows={3}
              placeholder="Description"
              autoComplete="off"
              onChange={handleChange}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default IncomeDuesAddChild;
